// extracted by mini-css-extract-plugin
module.exports = {"home":"home_home__35W5c","kpiContainer":"home_kpiContainer__2Axh6","blockContainer":"home_blockContainer__1dUGm","transactionContainer":"home_transactionContainer__Z3TE-"};